export default __webpack_public_path__ + "static/media/BrainBreak cards15.4fffb13e.png";